import axios from "axios";

export async function getFooter() {
    return await axios
        .get(`${process.env.REACT_APP_API_URL}getFooter.php`)
        .then((res) => res.data)
        .catch((err) => {
            console.log(err);
            return [];
        });
}
